import React from 'react';
import Packers from './components/Packers';
import Carrier from './components/Carrier';
import './App.css';

function App() {
  return (
    <div className="App">
      <Packers />
      <Carrier />
    </div>
  );
}

export default App;